import React from 'react'
import { Row } from '@/components/layout/layout'
import './order-refresh.scss'
import classnames from 'classnames'

interface OrderDataRefreshProps {
    loading?: boolean
    onClick: () => void
    refreshTime: string
}

const OrderDataRefresh: React.FC<OrderDataRefreshProps> = props => {
    return (
        <Row
            data-align-items-center
            data-font-size-16
            data-cursor-pointer
            style={{
                color: '#3C90FF',
            }}
            onClick={props.onClick}
        >
            {props.refreshTime && (
                <div data-color-999 data-font-size-16 data-margin-right-16>
                    {props.refreshTime}更新
                </div>
            )}

            <i
                className={classnames(
                    {
                        'is-refresh': props.loading,
                    },
                    'iconfont iconshuaxin',
                )}
                data-font-size-24
            />
            <div data-margin-left-4 data-margin-right-16>
                刷新
            </div>
        </Row>
    )
}

export default OrderDataRefresh
